export const TableNameValidateRule = {
  pattern: /^[a-z\u4E00-\u9FA5][a-z0-9\u4E00-\u9FA5_]*$/,
  message: '只能包含中文、数字、小写字母、下划线，不能以数字或下划线开头',
}
